export const supportsFancySelect = CSS.supports('appearance', 'base-select')
